<template>
  <div
    class="max-w-screen-lg xl:max-w-screen-xl mx-auto flex justify-center mt-16"
  >
    <div class="px-4 sm:px-6 md:px-8">
      <div
        class="font-montserrat text-2xl md:text-3xl lg:text-4xl font-semibold text-blue-700">
        Built on the Vega Protocol
      </div>
    </div>
  </div>
  <div
    class="max-w-screen-lg xl:max-w-screen-xl mx-auto flex justify-center mt-2"
  >
    <div class="px-4 sm:px-6 md:px-8">
      <div class="font-montserrat text-lg md:text-xl text-black-400">
        Find the documentation<br />of the Vega
        protocol here.
      </div>
    </div>
  </div>
  <div
    class="mt-8 xl:mt-10 max-w-screen-lg xl:max-w-screen-xl mx-auto flex justify-center"
  >
    <div class="px-4 sm:px-6 md:px-8 mb-14 sm:mb-20 xl:mb-8">
      <a
        class="shadow-lg font-montserrat w-full sm:w-auto flex-none bg-gradient-to-r from-blue-500 to-blue-400 hover:from-blue-600 hover:to-blue-500 text-white font-semibold leading-6 py-3 px-6 border border-transparent rounded-lg focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-900 focus:outline-none inline-flex items-baseline"
        href="https://docs.fairground.vega.xyz/docs/apis/"
        target="_blank"
        rel="noopener"
      >
        Go to Vega
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="18px"
          viewBox="0 0 24 24"
          width="18px"
          fill="white"
          class="h-6 w-6 fill-current place-self-end ml-1"
        >
          <g>
            <rect fill="none" height="24" width="24" />
            <path
              d="M14,12l-2,2l-2-2l2-2L14,12z M12,6l2.12,2.12l2.5-2.5L12,1L7.38,5.62l2.5,2.5L12,6z M6,12l2.12-2.12l-2.5-2.5L1,12 l4.62,4.62l2.5-2.5L6,12z M18,12l-2.12,2.12l2.5,2.5L23,12l-4.62-4.62l-2.5,2.5L18,12z M12,18l-2.12-2.12l-2.5,2.5L12,23l4.62-4.62 l-2.5-2.5L12,18z"/>
          </g>
        </svg>
      </a>
    </div>
    <div class="mb-16 invisible">_</div>
  </div>
</template>

<script>
export default {
  name: "LandingApi",
};
</script>
